/* OH ✦ HELLO — "Notify me" on fully sold-out collection cards.
   The button opens the product's quick view (the theme handles that via aria-controls).
   The restock sign-up itself is the Essential Pre-order "Notify me" box inside it —
   the same app used on the product page.
   - One-size products: the Notify box opens automatically.
   - Products with sizes: the shopper picks her size in the quick view, then taps
     "Notify me when available", so the alert is for the right size. */
(function () {
  if (window.__ohNotifyMe) return;
  window.__ohNotifyMe = true;

  var SELECTOR = '[data-essential-preorder-element="back-in-stock-button"]';

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-oh-notify][aria-controls]');
    if (!trigger) return;
    if (Number(trigger.getAttribute('data-oh-variant-count')) > 1) return;

    var modal = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!modal) return;

    var openNotifyBox = function () {
      var notifyButton = modal.querySelector(SELECTOR);
      if (notifyButton) { notifyButton.click(); return true; }
      return false;
    };
    if (openNotifyBox()) return;

    var observer = new MutationObserver(function () { if (openNotifyBox()) observer.disconnect(); });
    observer.observe(modal, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 8000);
  });
})();
